/*! @azure/msal-browser v4.23.0 2025-09-17 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";
export { contentError, userSwitch };
